import { Controller } from "@hotwired/stimulus"
import TomSelect      from "tom-select"

// Connects to data-controller="ts--select"
export default class extends Controller {
  static values = {
    url: String,
    options: Array,
    multi: Boolean,
    placeholder: String
  }

  connect() {
    if(this.element.tomselect) return

    this.element.setAttribute( "autocomplete", "random" );

    var config = {
      plugins: ['clear_button', 'dropdown_input'],
      maxOptions: false,
      render: {
        option: this.render_option,
        item: this.render_option
      }
    }

    // Check if this is a multiple select element
    if(this.element.multiple || this.element.hasAttribute('multiple')) {
      config.plugins = ['remove_button'];
      config.closeAfterSelect = false;
      config.hideSelected = false;
      config.maxItems = null;
      config.controlInput = '<input type="text" autocomplete="off" size="1" style="min-height: 20px;">';
    }

    if(this.hasPlaceholderValue) {
      config.placeholder = this.placeholderValue
    }

    if(this.hasOptionsValue) {
      config.options = this.optionsValue
    }

    this.tomSelect = new TomSelect(this.element, config);
  }

  disconnect() {
    if(this.tomSelect) {
      this.tomSelect.destroy()
      this.tomSelect = null
    }
  }

  render_option(data, escape) {
    if(data.sub)
      return `
      <div>
        <div class="text">${escape(data.text)}</div>
        <div class="sub">${escape(data.sub)}</div>
      </div>`
    else
      return `<div>${escape(data.text)}</div>`
  }

}
